import { M365AppData } from '../store/schema/M365AppData';
import { getStore } from '../store/store';

export default function getM365AppData(appId: string): M365AppData {
    return getStore().appServiceApps.filter(app => app.id === appId)[0];
}
